import { graphql, PageProps } from 'gatsby'
import React from 'react'
import Homepage from '../types/pages/homepage'
import { Page } from '@superrb/gatsby-addons/components'
import { PageStub } from '@superrb/gatsby-addons/types'
import HomepageSection, * as SectionTypes from '../types/pages/homepage/section'
import * as Sections from '../components/homepage-section/index'
import { StructuredData } from '@superrb/gatsby-addons/components'
import { Seo } from '@superrb/gatsby-addons/components'

const Index = ({
  data,
}: PageProps<
  { homepage: Homepage; homepageSections: { nodes: HomepageSection[] } },
  PageStub
>) => {
  const page = data.homepage
  if (!page) {
    return null
  }

  const {
    data: { page_title },
  } = page

  return (
    <>
      <Page page={page}>
        {data.homepageSections?.nodes?.map(
          (section: HomepageSection, index: number) => {
            const Component = Sections[section.type]

            return (
              <Component
                {...(section as SectionTypes[section.type])}
                key={index}
              />
            )
          },
        )}
        <StructuredData.Organisation />
      </Page>
    </>
  )
}

export const Head = ({ data }: PageProps<
  { homepage: Homepage; homepageSections: { nodes: HomepageSection[] } },
  PageStub
>) =>{
  const page = data.homepage
  if (!page) {
    return null
  }

  return (
    <Seo data={page?.data} />
  )
}

export const query = graphql`
  query HomepageQuery($id: String, $lang: String) {
    homepage: homepage(id: { eq: $id }, lang: { eq: $lang }) {
      ...Homepage
    }
    homepageSections: allHomepageSection(
      filter: { lang: { eq: $lang } }
      sort: { metadata: { order: ASC } }
    ) {
      nodes {
        ... on HomepageSectionHero {
          ...HomepageSectionHero
        }
      }
    }
  }
`

export default Index
